import {useContext, useEffect, useState} from "react";
import {createTransferOrder, Order, OrderFormValues, OrderStatus} from "../../../app/models/order";
import {Store} from "../../../app/stores/store-root";
import {Ticket} from "../../../app/models/Ticket";
import {FormBehavior, NewOrderFormBehaviour, CalculateFormBehaviour} from "./order-form-behaviour";



export const useCurrentOrder = (orderId: string, setLoading: any) => {
    let order: OrderFormValues
    const [FormBehaviour, SetFormBehaviour] = useState<FormBehavior>(NewOrderFormBehaviour);
    const store = useContext(Store);
    const [Order, SetOrder] = useState<OrderFormValues>(new OrderFormValues());

    useEffect(() => {
        if (orderId) {
            setLoading(true);
            console.log('useCurrentOrder - called')
            store.Orders.LoadOrderByReference(orderId).then((found: Order | undefined) => {
                order = new OrderFormValues(found);
                SetOrder(order);
                setLoading(false);
                SetFormBehaviour(CalculateFormBehaviour(order, store));
            })
        } else {
            order = createTransferOrder(Order, store);
            console.log("useCurrentOrder - created Order: ", order);
            SetOrder(order);
        }
    }, [orderId, store])

    return {Order: Order, ...FormBehaviour};
}

export const useCurrentOrderTickets = (orderId: string, setLoading: any) => {
    const store = useContext(Store);
    const isAdmin = store.Users.isAdmin;
    const [tickets, setTickets] = useState<Ticket[]>([]);

    useEffect(() => {
        if (orderId && isAdmin) {
            setLoading(true);
            store.SupportTickets.LoadOpenTicketsForOrder(orderId).then((tickets) => {
                setTickets(tickets);
                console.log(`useCurrentOrderTickets - returned tickets for ${orderId}`, tickets)
                setLoading(false);
            });
        }
    }, [orderId, store])
    return tickets;
}


export const useLookups = (setLoading: any) => {
    const store = useContext(Store);

    useEffect(() => {
        setLoading(true);
        store.Lookups.loadLookups();
        store.Exchanges.loadExchanges().finally(() => setLoading(false));
    }, [store])
}




